// Multi Sede Usuarios: selector múltiple de sedes (mismo patrón que
// GrupoUsuariosAgregarPage). La PRIMERA sede seleccionada es la primaria
// (TMUSE10.SedCod); todas se registran en el detalle TMUSE20.
import type { UsuarioFormCamposProps } from "./UsuarioFormCampos/UsuarioFormCampos.types";
import { UsuarioFormCabecera } from "./UsuarioFormCampos/UsuarioFormCabecera";
import { UsuarioFormDatosPersonales } from "./UsuarioFormCampos/UsuarioFormDatosPersonales";
import { UsuarioFormDatosLaborales } from "./UsuarioFormCampos/UsuarioFormDatosLaborales";

// DT1 (refactor por tamaño): cuerpo de campos del formulario de usuario.
// Toda la lógica (estado, hooks, handlers, API) permanece en UsuarioFormPage;
// aquí sólo vive el JSX presentacional, recibiendo lo necesario por props.
// Las secciones (cabecera, datos personales, datos laborales) viven en
// ./UsuarioFormCampos y se componen aquí sin cambiar el DOM resultante.
export const UsuarioFormCampos = (props: UsuarioFormCamposProps) => {
    return (
        <div className="row border p-1 pb-2 rounded-5 g-2">

            <UsuarioFormCabecera {...props} />
            <UsuarioFormDatosPersonales {...props} />
            <UsuarioFormDatosLaborales {...props} />

        </div>
    )
}
